<template>
  <div class="video-container">
    <youtube v-bind="customAttr" v-on="$listeners" @ready="showVideoLoader = false" />
    <loader-rectangles v-if="showVideoLoader" class="loader-rectangles" />
  </div>
</template>

<script>
import { getIdFromUrl, Youtube } from 'vue-youtube';
import LoaderRectangles from '@/components/loader-rectangles';

export default {
  name: 'YoutubeWrapper',
  components: {
    Youtube,
    LoaderRectangles,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showVideoLoader: true,
    };
  },
  computed: {
    videoId() {
      return getIdFromUrl(this.url);
    },
    customAttr() {
      return {
        'fit-parent': true,
        resize: true,
        ...this.$attrs,
        'video-id': this.videoId,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  min-height: 430px;

  @media (max-width: 991px) {
    min-height: 150px;
  }

  .loader-rectangles {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
    transform: translate(-50%, -50%);
  }
}
</style>
